<template>
  <div>
    <div class="form-section">      
      <h3>Thông tin tài khoản</h3>
      <div class="login-inner-form">
        <div class="form-group form-box">
            <input type="text" name="fullname" readonly="readonly" class="input-text" :value="`Họ và tên: ${user.fullname || 'Vô Danh Tiểu Tốt'}`">
            <i class="flaticon-user"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="email" readonly="readonly" class="input-text" :value="`Email: ${user.email || 'abc@gmail.com'}`">
            <i class="flaticon-mail"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="phone" readonly="readonly" class="input-text" :value="`Phone: ${user.phone || '043113' }`">
            <i class="flaticon-password"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="account" readonly="readonly" class="input-text" :value="`ID Game: ${user.account || 'gaconlonton'}`">
            <i class="flaticon-password"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="pass2" readonly="readonly" class="input-text" :value="`Mão bảo vệ: ${user.sec_pwd ? 'Đã cài đặt' : 'Chưa cài đặt'}`">
            <i class="flaticon-password"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="point" readonly="readonly" class="input-text" :value="`Point: ${ numberFormat(user.point || 0) } @`">
            <i class="flaticon-search"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="phone" readonly="readonly" class="input-text" :value="`Point tích lũy: ${ numberFormat(user.point_per_week || 0) } / 50,000 @`">
            <i class="flaticon-password"></i>
          </div>
          <div class="form-group form-box">
            <input type="text" name="phone" readonly="readonly" class="input-text" :value="`IP gần nhất: ${ user.last_ip || 'xxx.xxx.xxx.xxx' }`">
            <i class="flaticon-password"></i>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VModal from 'vue-js-modal'

  Vue.use(VModal)

  export default {
    name: 'AccountInformation',
    props: {
      tqc_api: String,
      user: {}
    },
    mounted() {
      this.$emit('get-info')
    },
    methods: {
      activeByPhone(rel) {
        /* this.ifm_src = `https://pay.fortumo.com/mobile_payments/${rel}`
        this.show() */
        window.open(`https://pay.fortumo.com/mobile_payments/${rel}`)
      },
      show() {
        this.$modal.show('activate-form');
      },
      beforeClose() {
        this.$emit('get-info')
      },
      numberFormat(number) {
        const options = {
          style: 'decimal', // 'decimal' for standard decimal formatting
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        };

        return number.toLocaleString(0, options);
      },
    },
    data() {
      return {
        ifm_src: '',
      }
    },
  }
</script>
